import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
  statusError: null,
  statusLoading: false,
  actionType: null,
  confDetails: {},
  agentDetails: {},
  roomEndTimes: {},
};

//1. Leave Conf Room
const leaveConfStart = (state, action) => {
  return updateObject(state, {loading: true, actionType: 'leaveConf'});
};

const leaveConfSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    actionType: null,
  });
};

const leaveConfFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false, actionType: null});
};

//2. Join Conf Room
const joinConfStart = (state, action) => {
  return updateObject(state, {loading: true, actionType: action.actionType});
};

const joinConfSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    actionType: null,
  });
};

const joinConfFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false, actionType: null});
};

//3. Get Conf Room Details
const getConfDetailsStart = (state, action) => {
  return updateObject(state, {statusLoading: true});
};

const getConfDetailsSuccess = (state, action) => {
  const rooms = action.confDetails?.room_details || [];
  const updatedEndTimes = { ...state.roomEndTimes };

  if (rooms.length) {
    rooms.forEach((room) => {
      const key = room.chan_name || room.cust_ph_no;
      if (!key) return;
      if (room.conf_leave !== "1" && updatedEndTimes[key]) {
        delete updatedEndTimes[key];
      }
    });
  }

  return updateObject(state, {
    statusError: null,
    statusLoading: false,
    confDetails: action.confDetails,
    roomEndTimes: updatedEndTimes,
  });
};

const getConfDetailsFail = (state, action) => {
  return updateObject(state, {statusError: action.error, statusLoading: false});
};

//4. Conf Disconnect
const confDisconnectStart = (state, action) => {
  return updateObject(state, {loading: true, actionType: 'confDisconnect'});
};

const confDisconnectSuccess = (state, action) => {
  const key = action.channel;
  const updatedEndTimes = key
    ? {
        ...state.roomEndTimes,
        [key]: action.endTime,
      }
    : state.roomEndTimes;

  return updateObject(state, {
    error: null,
    loading: false,
    actionType: null,
    roomEndTimes: updatedEndTimes,
  });
};

const confDisconnectFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false, actionType: null});
};

//5. Conf Back to agent
const backToAgentStart = (state, action) => {
  return updateObject(state, {loading: true, actionType: 'backToAgent'});
};

const backToAgentSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    actionType: null,
  });
};

const backToAgentFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false, actionType: null});
};

//6. Conf Mute
const confMuteStart = (state, action) => {
  return updateObject(state, {loading: true, actionType: action.actionType});
};

const confMuteSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    actionType: null,
  });
};

const confMuteFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false, actionType: null});
};

//7. Conf Dial
const confDialStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const confDialSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const confDialFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

//8. Send DTMF
const sendDtmfStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const sendDtmfSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const sendDtmfFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

//9 Get Conf Online Agent

const getOnlineAgentStart = (state, action) =>{
  return updateObject(state, {statusLoading: true});
}

const getOnlineAgentSuccess = (state, action) =>{
  return updateObject(state, {
    statusError: null,
    statusLoading: false,
    agentDetails: action.agentDetails,
  })
}

const getOnlineAgentFail = (state, action) =>{
  return updateObject(state, {statusError: action.error, statusLoading: false})
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LEAVE_CONF_START:
      return leaveConfStart(state, action);
    case actionTypes.LEAVE_CONF_SUCCESS:
      return leaveConfSuccess(state, action);
    case actionTypes.LEAVE_CONF_FAIL:
      return leaveConfFail(state, action);

    case actionTypes.JOIN_CONF_START:
      return joinConfStart(state, action);
    case actionTypes.JOIN_CONF_SUCCESS:
      return joinConfSuccess(state, action);
    case actionTypes.JOIN_CONF_FAIL:
      return joinConfFail(state, action);

    case actionTypes.GET_CONF_DETAIL_START:
      return getConfDetailsStart(state, action);
    case actionTypes.GET_CONF_DETAIL_SUCCESS:
      return getConfDetailsSuccess(state, action);
    case actionTypes.GET_CONF_DETAIL_FAIL:
      return getConfDetailsFail(state, action);

    case actionTypes.CONF_DISCONNECT_START:
      return confDisconnectStart(state, action);
    case actionTypes.CONF_DISCONNECT_SUCCESS:
      return confDisconnectSuccess(state, action);
    case actionTypes.CONF_DISCONNECT_FAIL:
      return confDisconnectFail(state, action);

    case actionTypes.CONF_DIAL_START:
      return confDialStart(state, action);
    case actionTypes.CONF_DIAL_SUCCESS:
      return confDialSuccess(state, action);
    case actionTypes.CONF_DIAL_FAIL:
      return confDialFail(state, action);

    case actionTypes.BACK_TO_AGENT_START:
      return backToAgentStart(state, action);
    case actionTypes.BACK_TO_AGENT_SUCCESS:
      return backToAgentSuccess(state, action);
    case actionTypes.BACK_TO_AGENT_FAIL:
      return backToAgentFail(state, action);

    case actionTypes.CONF_MUTE_START:
      return confMuteStart(state, action);
    case actionTypes.CONF_MUTE_SUCCESS:
      return confMuteSuccess(state, action);
    case actionTypes.CONF_MUTE_FAIL:
      return confMuteFail(state, action);

    case actionTypes.SEND_DTMF_START:
      return sendDtmfStart(state, action);
    case actionTypes.SEND_DTMF_SUCCESS:
      return sendDtmfSuccess(state, action);
    case actionTypes.SEND_DTMF_FAIL:
      return sendDtmfFail(state, action);
    
    case actionTypes.ONLINE_AGENT_START:
        return getOnlineAgentStart(state,action);
    case actionTypes.ONLINE_AGENT_SUCCESS:
         return getOnlineAgentSuccess(state, action);
    case actionTypes.ONLINE_AGENT_FAIL:
          return getOnlineAgentFail(state, action);         

    default:
      return state;
  }
};

export default reducer;
